import {DrawerRecommendation_AYExclusivesSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/recommendations.types';
import {useTrackOriginClick} from '@aboutyou/tracking';
import {
  COLORS,
  GenericIconName,
  Icon,
  Text,
  UnstyledLink,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

interface NavigationExclusivesProps {
  exclusives: DrawerRecommendation_AYExclusivesSection;
}

export const NavigationExclusives = ({
  exclusives,
}: NavigationExclusivesProps) => {
  const trackOriginClick = useTrackOriginClick();
  return (
    <Container data-testid="exclusiveContainer">
      <ExclusivesHeadlineContainer>
        <Text data-testid="exclusiveSectionTitle" weight="bold" size="px20">
          {exclusives.headline}
        </Text>
      </ExclusivesHeadlineContainer>
      <LinksContainer data-testid="ExclusiveDropsLiveContainer">
        {exclusives.exclusiveLinks.map(link => (
          <UnstyledLink
            data-testid={`DropsAndLiveListItem_${link.path.url}`}
            key={link.path.url}
            onClick={trackOriginClick('exclusive')}
            to={link.path.url}
            aria-label={undefined}
          >
            <ExclusiveLinkContainer>
              <Text weight="bold" size="px16">
                {link.label}
              </Text>
              <Icon size="XS" asset={GenericIconName.ArrowRight}></Icon>
            </ExclusiveLinkContainer>
          </UnstyledLink>
        ))}
      </LinksContainer>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px 0;
`;

const ExclusivesHeadlineContainer = styled.div`
  padding: 20px 0;
  text-align: center;
`;

const LinksContainer = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ExclusiveLinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;
  background-color: ${COLORS.Grey4};
  border-radius: 2px;
`;
